import React, { useState, useEffect } from "react";
import { dateString, success } from "../utils/common_utils";
import { getUser, isValidUser, refreshHomePageDetails } from "../utils/auth_utils";
import {txbb} from "../common_components/text_style_components"
import IndefiniteProgressBar from "../common_components/indefinite_progress_bar";
import {LinkUITealBold } from "../common_components/common_links";
import PosthogService from "../utils/tracking_utils";

function UserAccount() {
    const [user, setUser] = useState(getUser())
    const [paymentValidTill, SetPaymentValidity] = useState(dateString(0))
    const [showProgress, setShowProgress]=useState(false)
    //console.log(user);
    const logout = (e) => {
      e.preventDefault();
      //PosthogService.logout()
      localStorage.clear()
      window.location.reload();
    };

    useEffect(() => {
      setShowProgress(true)
      refreshHomePageDetails(true, (data)=>{
        setShowProgress(false)
        if(data && success(data.status) && isValidUser(data.user)){
          let nw=data.user 
          setUser(nw)
          SetPaymentValidity(dateString(user.paymentValidTill))
        }
      })
 
 }, []); // empty bracket means there are no dependencies which will make useEffect re run
  
    return (
      <div className="">
        <div className="flex flex-col justify-center items-center
         pt-4 leading-8">
        { showProgress && <IndefiniteProgressBar />}

        <div className="text-xl text-teal-600">
            
            Account Details <br />

            <span className="text-sm mt-4 text-black">
              {user.email}</span> <br/>
            
           {
            <div className="text-gray-800 text-sm">
             Number of Interview Credits Left : &nbsp;&nbsp;
             <span className="font-bold text-xl text-teal-600">
              {""+(user.interviewCreditsLeft/2)}</span>
            <br />
            </div> 
           }

           { user.paymentValidTill>1000 &&   <span className="text-sm mt-4 text-black">
             Payment valid till :  {paymentValidTill}</span>  
          }
        </div>

        <div className="mt-8">
          <a className="text-teal-600 underline 
          font-bold text-xl font-mono
          hover:text-teal-700 " 
          href="/evaluations">View Past Interviews </a>
         
          
        </div>
        <div className="mb-6 flex items-center justify-center">
          <button
            onClick={logout}
            className=" bg-red-600 text-white px-4 py-2 mt-8 rounded font-semibold hover:bg-red-700"
          >
            Logout
          </button>
        </div>
        </div>
      </div>
    );
  }

  export default UserAccount;